import { RouteError } from '../error/route-error';

export function routerErrorHandler() {
  throw new RouteError();
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/factories/router-error-handler.factory.ts